import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Navbar from '../../components/Navbar';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ld from '../../images/load.gif';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import styles from '../../styles/verifyemail.module.css';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const { users } = useSelector((state) => state);

  const verify = async () => {
    if (users?.isloggedin) {
      setLoading(false);
      navigate('/');
      return;
    }

    if (!code) {
      setVerificationStatus('error');
      toast.error('Verification code is missing.', {
        position: 'bottom-right',
        theme: 'colored',
        autoClose: 4000
      });
      setTimeout(() => {
        navigate('/login');
      }, 3000);
      setLoading(false);
      return;
    }

    try {
      const res = await axios.post(`https://chatting-club-backend.onrender.com/api/users/verify-email`, { 
        code: code
      });

      if (res.data.success === true) {
        setVerificationStatus('success');
        toast.success('✅ Email verified successfully! Welcome to Chat!', {
          position: 'bottom-right',
          theme: 'colored',
          autoClose: 3000
        });
        
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      } else {
        setVerificationStatus('error');
        toast.error(res.data.message || 'Verification failed. Please try again.', {
          position: 'bottom-right',
          theme: 'colored',
          autoClose: 4000
        });
        
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
    } catch (error) {
      setVerificationStatus('error');
      const errorMessage = error.response?.data?.message || 'Something went wrong. Please try again.';
      toast.error(errorMessage, {
        position: 'bottom-right',
        theme: 'colored',
        autoClose: 4000
      });
      
      setTimeout(() => {
        navigate('/login');
      }, 3000);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    verify();
  }, [code]);

  return (
    <div className={styles.verifyContainer}>
      <div className={styles.verifyContent}>
        <div className={styles.verifyCard}>
          {loading ? (
            <div className={styles.loadingState}>
              <div className={styles.loaderWrapper}>
                <img src={ld} className={styles.loaderImage} alt="Verifying..." />
              </div>
              <h3 className={styles.loadingTitle}>Verifying Your Email</h3>
              <p className={styles.loadingText}>Please wait while we verify your email address...</p>
              <div className={styles.loadingDots}>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
                <span className={styles.dot}></span>
              </div>
            </div>
          ) : verificationStatus === 'success' ? (
            <div className={styles.successState}>
              <div className={styles.successIcon}>✅</div>
              <h3 className={styles.successTitle}>Email Verified!</h3>
              <p className={styles.successText}>
                Your email has been successfully verified. You can now log in and start chatting with your friends!
              </p>
              <button 
                onClick={() => navigate('/login')} 
                className={styles.redirectBtn}
              >
                Go to Login
              </button>
            </div>
          ) : (
            <div className={styles.errorState}>
              <div className={styles.errorIcon}>❌</div>
              <h3 className={styles.errorTitle}>Verification Failed</h3>
              <p className={styles.errorText}>
                We couldn't verify your email. The link might be expired or invalid. Please request a new verification link.
              </p>
              <button 
                onClick={() => navigate('/login')} 
                className={styles.redirectBtn}
              >
                Back to Login
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default VerifyEmail;